module.exports = __webpack_public_path__ + "img/cuf-logo.40800115.svg";